import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ListItem } from '../../../../models/api/core/list/list-item';
import { AlertsService } from '../../../../services/alerts/alerts.service';
import { InputComponent } from '../../../core/controls/input.component';
import { SelectComponent } from '../../../core/controls/select.component';

@Component({
  selector: 'app-lag-time-option',
  imports: [SelectComponent, InputComponent],
  template: `
    <div
      class="tw-col-span-2 tw-flex"
      role="group"
      aria-labelledby="lag-from-label"
    >
      <span
        class="label tw-grow tw-font-bold tw-pt-2"
        id="lag-from-label"
        >From</span
      >
      <app-select
        class="tw-w-[250px]"
        [options]="alerts.lagFrom"
        optionLabel="description"
        [optionValue]="null"
        [control]="fromControl"
        label=""
        [filter]="false"
        [virtualScroll]="false"
        [showClear]="false"
        [showHeader]="false"
      />
      <app-select
        class="tw-w-[250px]"
        [options]="lagToOptions"
        optionLabel="description"
        [optionValue]="null"
        [control]="toControl"
        label="To"
        [filter]="false"
        [virtualScroll]="false"
        [showClear]="false"
        [showHeader]="false"
      />
    </div>

    <div
      class="tw-col-span-2 tw-flex"
      role="group"
      aria-labelledby="lag-time-label"
    >
      <span
        class="label tw-grow tw-font-bold tw-pt-2"
        id="lag-time-label"
        >The lag time is</span
      >
      <app-select
        class="tw-w-[250px]"
        [options]="alerts.lagOp"
        optionLabel="description"
        [optionValue]="null"
        [control]="opControl"
        label="Condition"
        [filter]="false"
        [virtualScroll]="false"
        [showClear]="false"
        [showHeader]="false"
      />
      <div class="tw-max-w-[100px]">
        <app-input
          type="Integer"
          [control]="daysControl"
          label="Days"
        ></app-input>
      </div>
    </div>
  `,
  styles: ``,
})
export class LagTimeOptionComponent implements OnInit {
  alerts = inject(AlertsService);

  @Input()
  fromControl: FormControl<any>;

  @Input()
  toControl: FormControl<any>;

  @Input()
  opControl: FormControl<any>;

  @Input()
  daysControl: FormControl<any>;

  lagToOptions: ListItem[] = [];

  ngOnInit(): void {
    this.toControl.addValidators([Validators.required]);
    this.opControl.addValidators([Validators.required]);
    this.daysControl.addValidators([Validators.required]);

    if (!this.fromControl.value) {
      this.fromControl.setValue(
        this.alerts.find(this.alerts.lagFrom, 'DATE_EVENT'),
      );
    }

    if (!this.toControl.value) {
      this.toControl.setValue(null);
    }

    if (!this.opControl.value) {
      this.opControl.setValue(
        this.alerts.find(this.alerts.lagOp, 'GreaterThanEqualTo'),
      );
    }

    if (this.daysControl.value == null) {
      this.daysControl.setValue(3);
    }

    this.updateToOptions(this.fromControl.value?.value);
    this.fromControl.valueChanges.subscribe((value) => {
      this.updateToOptions(value?.value);
    });
  }

  private updateToOptions(fromValue: string | null) {
    const allowed: Record<string, string[]> = {
      DATE_EVENT: [
        'CLAIM_MADE_DATE',
        'DATE_RPT_BY_CLIENT',
        'DATE_RPTED_CMS',
        'DATE_CREATE',
        'DATE_OPEN',
        'DATE_CLOSE',
      ],
      CLAIM_MADE_DATE: [
        'DATE_RPT_BY_CLIENT',
        'DATE_RPTED_CMS',
        'DATE_CREATE',
        'DATE_OPEN',
        'DATE_CLOSE',
      ],
      DATE_RPT_BY_CLIENT: [
        'DATE_RPTED_CMS',
        'DATE_CREATE',
        'DATE_OPEN',
        'DATE_CLOSE',
      ],
      DATE_RPTED_CMS: ['DATE_CREATE', 'DATE_OPEN', 'DATE_CLOSE'],
      DATE_CREATE: ['DATE_OPEN', 'DATE_CLOSE'],
      DATE_OPEN: ['DATE_CLOSE'],
      DATE_STAT: ['DATE_CLOSE'],
      DATE_CLOSE: ['DATE_STAT'],
    };

    const allowedValues = allowed[fromValue || ''] || [];
    this.lagToOptions = this.alerts.lagTo.filter((item) =>
      allowedValues.includes(item.value),
    );

    const currentValue = this.toControl.value?.value;
    if (!currentValue || !allowedValues.includes(currentValue)) {
      this.toControl.setValue(null);
    }
  }
}
